const breakpointThresholds = {
    xs: 0,
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
    xxl: 1536,
};

export function getCurrentBreakpoint(width) {
    const entries = Object.entries(breakpointThresholds).sort((a, b) => b[1] - a[1]);
    for (const [label, minWidth] of entries) {
        if (width >= minWidth) return label;
    }
    return "xs";
}
export function isRightSideGapNeed(data, ind, currentKey) {
    let totalwidth = 0
    for (let i = 0; i <= ind; i++) {
        totalwidth += parseFloat(data?.[i]?.breakpoints?.[currentKey] || 0)
    }
    return !(totalwidth % 100 === 0)
}